type KnightBadgeProps = {
  accent: "ember" | "steel" | "acid" | "blood";
};

export function KnightBadge({ accent }: KnightBadgeProps) {
  return (
    <div className={`knight-badge knight-badge--${accent}`} aria-hidden="true">
      <svg
        className="knight-badge__svg"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31 73H66L63 61L70 50L64 34L53 20L37 18L29 30L36 38L33 47L24 58L31 73Z"
          fill="currentColor"
          opacity="0.92"
        />
        <path
          d="M42 26C44.2 26 46 24.2 46 22C46 19.8 44.2 18 42 18C39.8 18 38 19.8 38 22C38 24.2 39.8 26 42 26Z"
          fill="#0A0D10"
        />
        <path
          d="M31 73H66"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
